import { render, staticRenderFns } from "./PotentialResourcesEdit.vue?vue&type=template&id=27917a10&scoped=true&"
import script from "./PotentialResourcesEdit.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesEdit.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PotentialResourcesEdit.vue?vue&type=style&index=1&id=27917a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27917a10",
  null
  
)

export default component.exports